import module from 'app/module.js'

function getObjectValue (objectPath, context) {
  let propertyArray = objectPath.split('.')
  let propertyReference = context

  for (let i = 0; i < propertyArray.length; i++) {
    if (propertyReference[propertyArray[i]]) {
      propertyReference = propertyReference[propertyArray[i]]
    } else {
      return undefined
    }
  }

  return propertyReference
}

function stateAlreadyInBreadcrumbs (state, breadcrumbs) {
  let alreadyUsed = false
  for (let i = 0; i < breadcrumbs.length; i++) {
    if (breadcrumbs[i] === state.name) {
      alreadyUsed = true
    }
  }

  return alreadyUsed
}

class AppBreadcrumbsService {
  constructor ($interpolate, $state, $timeout, $translate, $q) {
    this.$interpolate = $interpolate
    this.$state = $state
    this.$timeout = $timeout
    this.$translate = $translate
    this.$q = $q
    this.displaynameProperty = 'data.title'
    this.abstractProxyProperty = 'data.titleProxy'
    this.breadcrumbs = []
    this.update = () => (this.updateBreadcrumbsArray())
  }

  Breadcrumb (displayName, route) {
    return this.$translate(displayName)
      .then((name) => ({displayName: name, route: route}))
      .catch((name) => ({displayName: name, route: route}))
  }

  updateBreadcrumbsArray () {
    const breadcrumbs = []
    const routes = []
    const pending = []
    const title = []
    let currentState = this.$state.$current

    while (currentState && currentState.name !== '') {
      const workingState = this.getWorkingState(currentState)

      if (workingState) {
        const displayName = this.getDisplayName(workingState)

        if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, routes)) {
          pending.push(this.Breadcrumb(displayName, workingState.name))
          routes.push(workingState.name)
        }
      }
      currentState = currentState.parent
    }

    return this.$q.all(pending)
      .then((states) => {
        states.forEach((state) => {
          breadcrumbs.push(state)
          title.unshift(state.displayName)
        })

        this.breadcrumbs.length = 0
        breadcrumbs.reverse().forEach((item) => (this.breadcrumbs.push(item)))

        return this.$timeout(() => title && title !== '' ? title.join(' / ') : '', 0)
      })
  }

  getWorkingState (currentState) {
    let workingState = currentState

    if (currentState.abstract === true) {
      if (typeof this.abstractProxyProperty !== 'undefined') {
        const proxyStateName = getObjectValue(this.abstractProxyProperty, currentState)

        if (proxyStateName) {
          workingState = this.$state.get(proxyStateName)
        } else {
          workingState = false
        }
      } else {
        workingState = false
      }
    }
    return workingState
  }

  getDisplayName (currentState) {
    if (!this.displaynameProperty) return currentState.name

    const propertyReference = getObjectValue(this.displaynameProperty, currentState)

    if (propertyReference === false) {
      return false
    } else if (typeof propertyReference === 'undefined') {
      return currentState.name
    } else {
      const interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : this.$state.$current.locals.globals
      return this.$interpolate(propertyReference)(interpolationContext)
    }
  }
}

module.service('AppBreadcrumbs', AppBreadcrumbsService)



// WEBPACK FOOTER //
// ./src/app/services/AppBreadcrumbs.js